const BODY_CLASS_ON_CATEGORY_PAGE = 'categorie';
const BODY_CLASS_ON_HOME = 'home';
const BODY_CLASS_ON_SUITE = 'single_suite';
const BODY_CLASS_ON_CONCEPT = 'concept';
const BODY_CLASS_ON_STEP2 = 'step2';
const BODY_CLASS_ON_STEP1 = 'step1';

export function setClass(classNames) {
  if (Array.isArray(classNames)) {
    classNames = classNames.join(' ');
  }
  document.body.className = classNames;
}

export function setBodyCategory() {
  setClass(BODY_CLASS_ON_CATEGORY_PAGE);
}

export function setBodyHome() {
  setClass(BODY_CLASS_ON_HOME);
}

export function setBodyStep2() {
  setClass(BODY_CLASS_ON_STEP2);
}

export function setBodyStep1() {
  setClass(BODY_CLASS_ON_STEP1);
}

export function setBodySuite() {
  setClass(BODY_CLASS_ON_SUITE);
}

export function setBodyConcept() {
  setClass(BODY_CLASS_ON_CONCEPT);
}



// WEBPACK FOOTER //
// ./src/helpers/body-class.helper.js